import { render, staticRenderFns } from "./IbRejectedTab.vue?vue&type=template&id=4f1e9a39"
import script from "./IbRejectedTab.vue?vue&type=script&lang=js"
export * from "./IbRejectedTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports